import initialStyle from './initial.style';
import alignStyle from './align.style';
import fadeInStyle from './fade-in.style';
import fadeOutStyle from './fade-out.style';
import onClickStyle from './on-click.style';

export default ({ align, onClick, opacity, visible }) => [
  initialStyle(opacity),
  alignStyle(align),
  visible ? fadeInStyle(align, opacity) : fadeOutStyle(align),
  onClick && onClickStyle,
];
